import React from 'react'
import { Card } from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const CaptableManagementRoundSkeleton = () => {
    return (
        <Card className='w-100 p-4 bg-white'>
            <div>
                <Skeleton
                    width={120}
                    height={20}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    className='mb-2'
                />
            </div>
            <div>
                {Array(5)
                    .fill(null)
                    .map((_, index) => (
                        <Skeleton
                            width={'100%'}
                            height={57}
                            baseColor='var(--kt-skeleton-bg-color)'
                            highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                    ))}
            </div>
        </Card>
    )
}

export default CaptableManagementRoundSkeleton
